var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("basic-container", { attrs: { id: "container" } }, [
    _c("div", { staticClass: "section" }, [
      _c("div", { staticClass: "title" }, [_vm._v("设备信息")]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                _c("span", { staticClass: "name" }, [_vm._v(" HID： ")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(_vm.initData.hardwareId) + " "),
                ]),
              ]),
              _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                _c("span", { staticClass: "name" }, [_vm._v(" UID： ")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(_vm.initData.sdkUserId) + " "),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                _c("span", { staticClass: "name" }, [_vm._v(" 渠道来源： ")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(_vm.initData.sdkChannel) + " "),
                ]),
              ]),
              _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                _c("span", { staticClass: "name" }, [_vm._v(" MAC： ")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(_vm.initData.mac) + " "),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                _c("span", { staticClass: "name" }, [_vm._v(" IP： ")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.initData.ip || "-"}(${
                        _vm.initData.address || "-"
                      })`
                    ) + " "
                  ),
                ]),
              ]),
              _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                _c("span", { staticClass: "name" }, [_vm._v(" App 版本号： ")]),
                _c("span", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(_vm.initData.appVersion) + " "),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "section" }, [
      _c("div", { staticClass: "title" }, [_vm._v("事件流   ")]),
      _c(
        "div",
        { staticClass: "content" },
        [_c("EventFlow", { ref: "EventFlow" })],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("div", { staticClass: "title" }, [_vm._v(" 实时质量")]),
        _c("cloudAppTimeQuality", {
          ref: "cloudAppTimeQuality",
          attrs: { uid: _vm.initData.sdkUserId },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("div", { staticClass: "title" }, [
          _c("div", [
            _vm._v("屏幕分享拉流实时质量"),
            _c(
              "span",
              {
                staticClass: "el-icon-refresh-left _btn",
                on: { click: _vm.renovateFlow },
              },
              [_vm._v(" 刷新")]
            ),
          ]),
        ]),
        _c("cloudAppRealTimeQuality", {
          ref: "cloudAppRealTimeQuality",
          attrs: { uid: _vm.initData.sdkUserId },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }